import _ from 'lodash'
import React from 'react'
import { Grid, Typography, Tooltip, IconButton } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/styles'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import SwitchMUI from '@material-ui/core/Switch'

const SwitchComponent = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: '8px 0',
        overflow: 'visible',
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.primary.main,
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <SwitchMUI
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    )
})

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
    },
    label: {
        marginRight: '0.25rem',
    },
}))

export const CustomSwitch = ({ label, description, checked, handleChange, name }) => {
    const classes = useStyles()
    return (
        <Grid container wrap="nowrap" alignItems="center">
            <Grid className={classes.wrapper}>
                {_.isString(label) ? <Typography className={classes.label}>{label}</Typography> : label}
                {!_.isEmpty(description) && (
                    <Grid className={classes.wrapper}>
                        <Tooltip title={description}>
                            <IconButton>
                                <HelpOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                )}
            </Grid>
            <SwitchComponent checked={checked} onChange={handleChange} name={name} />
        </Grid>
    )
}
